export default {
  SET_CATEGORY(state, payload) {
    state.EcomCategory = payload;
  },
  SET_DETAILED_CATEGORY(state, payload) {
    state.detailedCategory = payload;
  },
  SET_DETAILED_CATEGORYAll(state, payload) {
    state.detailedCategoryAll = payload;
  },
};
